import React, { useState } from 'react';
import './CommissionModal.css';

const CommissionModal = ({ commission, onClose, onApprove, onReject }) => {
  const [adminRemark, setAdminRemark] = useState('');
  const [loading, setLoading] = useState(false);

  const handleApprove = async () => {
    if (!adminRemark.trim()) {
      alert('Please enter an admin remark before approving.');
      return;
    }
    setLoading(true);
    await onApprove(commission.id, adminRemark);
    setLoading(false);
  };

  const handleReject = async () => {
    if (!adminRemark.trim()) {
      alert('Please enter an admin remark before rejecting.');
      return;
    }
    setLoading(true);
    await onReject(commission.id, adminRemark);
    setLoading(false);
  };

  const copyToClipboard = async (text) => {
    try {
      await navigator.clipboard.writeText(text);
      alert('Copied to clipboard!');
    } catch (err) {
      const textArea = document.createElement("textarea");
      textArea.value = text;
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();
      try {
        document.execCommand('copy');
        alert('Copied to clipboard!');
      } catch (err) {
        alert('Failed to copy');
      }
      document.body.removeChild(textArea);
    }
  };

  return (
    <div className="commission-modal-overlay" onClick={onClose}>
      <div className="commission-modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="commission-modal-header">
          <h2>IB Commission Withdrawal Request Details</h2>
          <button className="commission-modal-close" onClick={onClose}>
            <i className="fas fa-times"></i>
          </button>
        </div>

        <div className="commission-modal-body">
          {/* Request Information */}
          <div className="commission-section">
            <h3 className="commission-section-title">Request Information</h3>
            <div className="commission-details-grid">
              <div className="commission-detail-item">
                <span className="commission-detail-label">Request ID:</span>
                <span className="commission-detail-value">{commission.id}</span>
              </div>
              <div className="commission-detail-item">
                <span className="commission-detail-label">Email:</span>
                <span className="commission-detail-value">{commission.email}</span>
              </div>
              <div className="commission-detail-item">
                <span className="commission-detail-label">Commission Amount:</span>
                <span className="commission-detail-value commission-amount">
                  ${parseFloat(commission.total_commission || 0).toFixed(2)}
                </span>
              </div>
              <div className="commission-detail-item">
                <span className="commission-detail-label">Type:</span>
                <span className="commission-detail-value commission-type">{commission.type || 'N/A'}</span>
              </div>
              <div className="commission-detail-item">
                <span className="commission-detail-label">Request Date:</span>
                <span className="commission-detail-value">
                  {commission.created_at ? new Date(commission.created_at).toLocaleString() : 'N/A'}
                </span>
              </div>
            </div>
          </div>

          {/* Wallet Information */}
          <div className="commission-section">
            <h3 className="commission-section-title">Wallet Information</h3>
            <div className="commission-details-grid">
              <div className="commission-detail-item full-width">
                <span className="commission-detail-label">Wallet Address:</span>
                <div className="commission-wallet-container">
                  <span className="commission-wallet-address">
                    {commission.walletaddress || 'N/A'}
                  </span>
                  {commission.walletaddress && (
                    <button
                      className="commission-copy-btn"
                      onClick={() => copyToClipboard(commission.walletaddress)}
                      title="Copy wallet address"
                    >
                      <i className="fas fa-copy"></i> Copy
                    </button>
                  )}
                </div>
              </div>
              <div className="commission-detail-item">
                <span className="commission-detail-label">Network:</span>
                <span className="commission-detail-value">{commission.network || 'N/A'}</span>
              </div>
            </div>
          </div>

          {/* Additional Details */}
          {commission.user_remark && (
            <div className="commission-section">
              <h3 className="commission-section-title">User Remark</h3>
              <div className="commission-remark-box">
                {commission.user_remark}
              </div>
            </div>
          )}

          {/* Admin Remark */}
          <div className="commission-section">
            <h3 className="commission-section-title">Admin Remark</h3>
            <textarea
              className="commission-admin-remark"
              placeholder="Enter admin remark (required)..."
              value={adminRemark}
              onChange={(e) => setAdminRemark(e.target.value)}
              rows="4"
            />
          </div>
        </div>

        <div className="commission-modal-footer">
          <button
            className="commission-btn commission-btn-reject"
            onClick={handleReject}
            disabled={loading || !adminRemark.trim()}
          >
            {loading ? (
              <>
                <span className="commission-spinner"></span>
                Rejecting...
              </>
            ) : (
              <>
                <i className="fas fa-times-circle"></i>
                Reject Request
              </>
            )}
          </button>
          <button
            className="commission-btn commission-btn-approve"
            onClick={handleApprove}
            disabled={loading || !adminRemark.trim()}
          >
            {loading ? (
              <>
                <span className="commission-spinner"></span>
                Approving...
              </>
            ) : (
              <>
                <i className="fas fa-check-circle"></i>
                Approve Request
              </>
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default CommissionModal;
